export var TransactionType;
(function (TransactionType) {
    TransactionType["CREDIT"] = "CREDIT";
    TransactionType["PAYMENT"] = "PAYMENT";
    TransactionType["TRANSFER"] = "TRANSFER";
})(TransactionType || (TransactionType = {}));
export var TransactionRole;
(function (TransactionRole) {
    TransactionRole["APPT"] = "appt";
    TransactionRole["OVERTIME"] = "overtime";
    TransactionRole["PARTNERSHIP"] = "partnership";
    TransactionRole["PREPAID"] = "prepaid";
    TransactionRole["REFERRAL"] = "referral";
    TransactionRole["ROLLOVER"] = "rollover";
    TransactionRole["SPONSORED"] = "sponsored";
    TransactionRole["SUBSCRIPTION"] = "subscription";
    TransactionRole["TOPUP"] = "topup";
})(TransactionRole || (TransactionRole = {}));
export var CreditTransactionStatus;
(function (CreditTransactionStatus) {
    CreditTransactionStatus["SUCCEEDED"] = "SUCCEEDED";
    CreditTransactionStatus["REVERSED"] = "REVERSED";
    // FREE = 'FREE' let's get rid of this status, credits, payments, and transfers can all be free if their amount is 0, that should be enough
})(CreditTransactionStatus || (CreditTransactionStatus = {}));
export var HoldTransactionStatus;
(function (HoldTransactionStatus) {
    HoldTransactionStatus["PENDING"] = "HOLD_PENDING";
    HoldTransactionStatus["FAILED"] = "HOLD_FAILED";
    HoldTransactionStatus["SUCCEEDED"] = "HOLD_SUCCEEDED";
    HoldTransactionStatus["RELEASED"] = "HOLD_RELEASED";
})(HoldTransactionStatus || (HoldTransactionStatus = {}));
export var CaptureTransactionStatus;
(function (CaptureTransactionStatus) {
    CaptureTransactionStatus["PENDING"] = "CAPTURE_PENDING";
    CaptureTransactionStatus["FAILED"] = "CAPTURE_FAILED";
    CaptureTransactionStatus["SUCCEEDED"] = "CAPTURE_SUCCEEDED";
    CaptureTransactionStatus["REFUNDED"] = "CAPTURE_REFUNDED";
})(CaptureTransactionStatus || (CaptureTransactionStatus = {}));
export var TransferTransactionStatus;
(function (TransferTransactionStatus) {
    TransferTransactionStatus["PENDING"] = "TRANSFER_PENDING";
    TransferTransactionStatus["SUCCEEDED"] = "TRANSFER_SUCCEEDED";
    TransferTransactionStatus["FAILED"] = "TRANSFER_FAILED";
    TransferTransactionStatus["REVERSED"] = "TRANSFER_REVERSED";
})(TransferTransactionStatus || (TransferTransactionStatus = {}));
export var PayoutTransactionStatus;
(function (PayoutTransactionStatus) {
    PayoutTransactionStatus["PENDING"] = "PAYOUT_PENDING";
    PayoutTransactionStatus["SUCCEEDED"] = "PAYOUT_SUCCEEDED";
    PayoutTransactionStatus["FAILED"] = "PAYOUT_FAILED";
})(PayoutTransactionStatus || (PayoutTransactionStatus = {}));
//# sourceMappingURL=transaction.js.map